var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"setting-admin"}},[_vm._m(0),_c('tab-vertical-component',{staticStyle:{"margin-left":"-8px","margin-right":"-8px"},attrs:{"tabs":_vm.tabs}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white shade py-2 px-3 mb-4",staticStyle:{"margin-top":"15px"}},[_c('h3',{staticStyle:{"font-size":"20px"}},[_c('i',{staticClass:"bi bi-gear"}),_vm._v(" Settings ")])])
}]

export { render, staticRenderFns }